import React from 'react';

interface ArrowProps {
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    label?: string; // Kept for compatibility but ignored
    color?: string;
    labelColor?: string;
    labelOffset?: number;
}

export const Arrow: React.FC<ArrowProps> = ({
    x1,
    y1,
    x2,
    y2,
    color = "#4b5563"
}) => {
    const angleRad = Math.atan2(y2 - y1, x2 - x1);
    const angleDeg = angleRad * 180 / Math.PI;
    const midX = (x1 + x2) / 2;
    const midY = (y1 + y2) / 2;
    const headSize = 10;

    return (
        <g>
            <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth="2" />
            <g transform={`translate(${midX}, ${midY}) rotate(${angleDeg})`}>
                <polygon points={`0,0 ${-headSize},${-headSize / 2} ${-headSize},${headSize / 2}`} fill={color} />
            </g>
            {/* NO Internal Label Rendering */}
        </g>
    );
};
